// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-table {
  width: 100%;
  border-collapse: collapse;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-header-cell {
  font-weight: bold;
  padding: 0 1em 0 1em;
}

.mat-mdc-cell {
  padding: 0 1em 0 1em;
  font-size: 12px;
}

.headerText {
  text-transform: capitalize;
  display: block;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 20px;
}

.buttonDiv {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  gap: 10px;
  row-gap: 10px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm0tZGVsZXRpb24tZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBQTtFQUNBLHlCQUFBO0FBQ0Y7O0FBRUE7O0VBRUUsWUFBQTtFQUNBLG1CQUFBO0FBQ0Y7O0FBRUE7RUFDRSxpQkFBQTtFQUNBLG9CQUFBO0FBQ0Y7O0FBRUE7RUFDRSxvQkFBQTtFQUNBLGVBQUE7QUFDRjs7QUFFQTtFQUNFLDBCQUFBO0VBQ0EsY0FBQTtFQUNBLGVBQUE7RUFDQSxpQkFBQTtFQUNBLG9CQUFBO0FBQ0Y7O0FBRUE7RUFDRSxhQUFBO0VBQ0EseUJBQUE7RUFDQSxhQUFBO0VBQ0EsU0FBQTtFQUNBLGFBQUE7QUFDRiIsImZpbGUiOiJjb25maXJtLWRlbGV0aW9uLWRpYWxvZy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tYXQtbWRjLXRhYmxlIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGJvcmRlci1jb2xsYXBzZTogY29sbGFwc2U7XG59XG5cbi5tYXQtbWRjLXJvdyxcbi5tYXQtbWRjLWhlYWRlci1yb3cge1xuICBoZWlnaHQ6IDM1cHg7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG59XG5cbi5tYXQtbWRjLWhlYWRlci1jZWxsIHtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIHBhZGRpbmc6IDAgMWVtIDAgMWVtO1xufVxuXG4ubWF0LW1kYy1jZWxsIHtcbiAgcGFkZGluZzogMCAxZW0gMCAxZW07XG4gIGZvbnQtc2l6ZTogMTJweDtcbn1cblxuLmhlYWRlclRleHQge1xuICB0ZXh0LXRyYW5zZm9ybTogY2FwaXRhbGl6ZTtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGZvbnQtc2l6ZTogMjBweDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIHBhZGRpbmctYm90dG9tOiAyMHB4O1xufVxuXG4uYnV0dG9uRGl2IHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgcGFkZGluZzogMTBweDtcbiAgZ2FwOiAxMHB4O1xuICByb3ctZ2FwOiAxMHB4O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/components/utility/confirm-deletion-dialog/confirm-deletion-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AACF;AACA,wzCAAwzC","sourcesContent":[".mat-mdc-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.mat-mdc-row,\n.mat-mdc-header-row {\n  height: 35px;\n  white-space: nowrap;\n}\n\n.mat-mdc-header-cell {\n  font-weight: bold;\n  padding: 0 1em 0 1em;\n}\n\n.mat-mdc-cell {\n  padding: 0 1em 0 1em;\n  font-size: 12px;\n}\n\n.headerText {\n  text-transform: capitalize;\n  display: block;\n  font-size: 20px;\n  font-weight: bold;\n  padding-bottom: 20px;\n}\n\n.buttonDiv {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n  gap: 10px;\n  row-gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
